(ns quuppa.qsm.configuration.subs
  (:require [re-frame.core :as rf]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.events :as e]))

(rf/reg-sub
  ::value
  (fn []
    (q/subscribe e/authorized-qpes {}))
  (fn [authorized-qpes [_ qpe-identity k]]
    (get-in authorized-qpes [:result qpe-identity :configuration k])))
